import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'ellipsisName'
})
export class EllipsisNamePipe implements PipeTransform {

  transform(name: string, lettersCount: number): unknown {
    return name.length > lettersCount ? `${name.slice(0, lettersCount)}...` : name;
  }
}
